import Axios from "axios";

import { AuthAction } from "../../store/actions";
import Store from "../../store/index";
import variables from "../constants";

// const { BASE_URL } = variables;
const BASE_URL = process.env.REACT_APP_BASE_URL;

Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  ({ response }) => {
    if (response.status == 401) {
      try {
        localStorage.removeItem("authUser");
        Store.dispatch(AuthAction.SignInSuccess());
        window.location.reload();
      } catch (err) {}
    }
    return response;
  }
);

Axios.interceptors.request.use(
  function (config) {
    if (localStorage.getItem("authUser")) {
      config.headers = {
        ...config?.headers,
        Authorization: `Bearer ${
          JSON.parse(localStorage.getItem("authUser"))?.secret
        }`,
      };
      config.timeout = 600000;
      return config;
    } else {
      config.timeout = 600000;
      return config;
    }
  },
  function (error) {
    return Promise.reject(error);
  }
);
const CancelToken = Axios.CancelToken;

export default class ApiCaller {
  static Get = (endPoint = "", headers = {}, data = {}) => {
    return Axios.get(
      `${BASE_URL}${endPoint}`,
      {
        headers,
      },
      data
    )
      .then((res) => res)
      .catch((err) => err.response);
  };

  static Post = (endPoint = "", body = {}, headers = {}) => {
    return Axios.post(`${BASE_URL}${endPoint}`, body, {
      headers,
    })
      .then((res) => res)
      .catch((err) => err.response);
  };

  static Put = (endPoint = "", body = {}, headers = {}) => {
    return Axios.put(`${BASE_URL}${endPoint}`, body, {
      headers,
    })
      .then((res) => res)
      .catch((err) => err.response);
  };

  static Delete = (endPoint = "", body = {}, headers = {}) => {
    console.log(body, "ALiaaa");

    // Build URL safely: if `endPoint` already contains query params, use '&',
    // otherwise use '?'. Also only append body parameters when provided.
    let url = `${BASE_URL}${endPoint}`;
    if (body && Object.keys(body).length > 0) {
      const params = new URLSearchParams(body).toString();
      url += (endPoint.includes("?") ? "&" : "?") + params;
    }

    return Axios.delete(url, {
      headers,
    })
      .then((res) => res)
      .catch((err) => err.response);
  };

  static Patch = (endPoint = "", body = {}, headers = {}) => {
    return Axios.patch(`${BASE_URL}${endPoint}`, body, {
      headers,
    })
      .then((res) => res)
      .catch((err) => err.response);
  };
}
